import { Router } from "@angular/router";
import { SyncSchedule, SyncStatus } from "@app/core";
import { Column, Display, Table } from "@messaia/cdk";
import { SyncSection } from "../enums/sync-section";

@Table({
	endpoint: 'synchistory',
	addable: false,
	selectable: false,
	editable: false,
	deletable: false,
	rowNgClass: (row: SyncHistory) => {
		return {
			'succeeded': row.status == SyncStatus.Succeeded,
			'warn': row.status == SyncStatus.Pending || row.status == SyncStatus.Retry,
			'error': row.status == SyncStatus.Failed,
			'cancelled': row.status == SyncStatus.Cancelled,
		};
	},
	rowClick: (row: SyncHistory, router: Router) => {
		switch (row.section) {
			case SyncSection.Customer:
				router.navigate(['/customers/redirect', row.entityId]);
				break;

			case SyncSection.Order:
				router.navigate(['/orders/edit', row.entityId]);
				break;

			case SyncSection.OrderItem:
				router.navigate(['/orders/redirect/bundles', row.entityId]);
				break;

			case SyncSection.PhoneBookEntry:
				router.navigate(['/orders/phonebookentry/edit', row.entityId]);
				break;

			case SyncSection.Credit:
				router.navigate(['/orders/credits/edit', row.entityId]);
				break;

			case SyncSection.Bill:
				router.navigate(['/orders/bills/edit', row.entityId]);
				break;

			case SyncSection.BillBundle:
				router.navigate(['/orders/billbundles/edit', row.entityId]);
				break;

			default:
				break;
		}
	}
})
export class SyncHistory extends SyncSchedule {
	@Column({ index: 1, enumType: SyncSection, maxWidth: 120 })
	@Display($localize`:@@section:Section`)
	section: SyncSection;

	@Column({ index: 2, maxWidth: 75, showGtXl: true })
	@Display($localize`:@@entityId:Entity-ID`)
	entityId: number;

	@Column({ contentLength: 40, showGtXl: true })
	@Display($localize`:@@message:Message`)
	message: string;
}